/**
 * Dynamic environment-based configuration for API & CouchDB endpoints.
 * Priority order for environment resolution:
 * 1. Explicit build-time env vars: REACT_APP_COUCHDB_URL and REACT_APP_API_URL
 * 2. Environment flags from REACT_APP_DEPLOY_ENV or DEPLOY_ENV (prod|beta)
 */

// CRA only exposes vars prefixed with REACT_APP_; we also check DEPLOY_ENV for non-CRA contexts.
const rawDeployEnv = (process.env.REACT_APP_DEPLOY_ENV || process.env.DEPLOY_ENV || '').toLowerCase();
const nodeEnv = (process.env.NODE_ENV || 'development').toLowerCase();
const explicitDbUrl = (process.env.REACT_APP_COUCHDB_URL || '').trim();
const explicitApiUrl = (process.env.REACT_APP_API_URL || '').trim();

const isTestEnv = nodeEnv === 'test';
const isBetaEnv = rawDeployEnv === 'beta';
const isProdEnv = rawDeployEnv === 'prod' || (rawDeployEnv === '' && nodeEnv === 'production');
const isLocalEnv = nodeEnv === 'development' && !rawDeployEnv;

function requireUrl(value: string, envName: string): string {
	if (!value) {
		throw new Error(`[DbConfig] Missing required env var: ${envName}`);
	}
	return value;
}

export const DB_URL = explicitDbUrl || ((isLocalEnv || isTestEnv)
	? 'http://localhost:5984'
	: requireUrl(explicitDbUrl, 'REACT_APP_COUCHDB_URL'));

export const API_URL = explicitApiUrl || ((isLocalEnv || isTestEnv)
	? 'http://localhost:3001/api'
	: requireUrl(explicitApiUrl, 'REACT_APP_API_URL'));

// Helpful flags (optional export for consumers needing branching logic)
export const ENV_FLAGS = { isTestEnv, isLocalEnv, isBetaEnv, isProdEnv };